import * as React from "react";
import * as ReactDOM from "react-dom";
import Select from "react-select";
class SelectUpDown extends React.Component {
    mNode = null;
    constructor(props) {
        super(props);
        this.state = {
            up: false,
        };
    }
    componentDidMount() {
        this.mNode = ReactDOM.findDOMNode(this);
    }
    render() {
        const classes = ["select-up-down"];
        if (this.props.className) {
            classes.push(...this.props.className.split(" "));
        }
        if (this.state.up) {
            classes.push("select-up-down-up");
        }
        return (React.createElement(Select, { ...this.props, className: classes.join(" "), onOpen: this.onMenuOpen }));
    }
    get bounds() {
        return this.props.container
            ? this.props.container.getBoundingClientRect()
            : {
                top: 0,
                left: 0,
                bottom: window.innerHeight,
                right: window.innerWidth,
                height: window.innerHeight,
                width: window.innerWidth,
            };
    }
    onMenuOpen = () => {
        const bounds = this.bounds;
        const newUp = this.mNode.getBoundingClientRect().bottom >
            bounds.top + bounds.height / 2;
        // force redraw to ensure the menu gets rendered too
        this.setState({ up: newUp });
        if (this.props.onOpen !== undefined) {
            this.props.onOpen.apply(this);
        }
    };
}
export default SelectUpDown;
